import { createFileRoute, notFound } from '@tanstack/react-router';

import { FixtureEditPage } from '@/components/admin/sport/fixture-edit-page';
import { useAdminEditPageKey } from '@/hooks/use-admin-navigate';
import { adminHead } from '@/lib/seo';
import { resolveClubSide } from '@/lib/sport/seo';
import { adminGetFixtureFn } from '@/server/functions/sport';

export const Route = createFileRoute('/_admin/admin/sport/matches_/$id')({
    component: MatchEditRoute,
    head: ({ params, loaderData }) => {
        const fixture = loaderData?.fixture;
        const title =
            fixture && loaderData
                ? `${resolveClubSide(loaderData.teams, loaderData.clubs, fixture.homeTeamId).label} - ${resolveClubSide(loaderData.teams, loaderData.clubs, fixture.awayTeamId).label}`
                : 'עריכת משחק';
        return adminHead(title, `/admin/sport/matches/${encodeURIComponent(params.id)}`);
    },
    staleTime: 0,
    preloadStaleTime: 0,
    loader: async ({ params }) => {
        const data = await adminGetFixtureFn({ data: { id: params.id } });
        if (!data) throw notFound();
        return data;
    },
});

function MatchEditRoute() {
    const data = Route.useLoaderData();
    const key = useAdminEditPageKey(data.fixture.id);
    return <FixtureEditPage key={key} data={data} />;
}
